module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-regular.1321ef46.eot";